import { Avatar } from '@seek/avatar';

import { TextSkeleton } from 'src/libs/TextSkeleton';

import { TableRowLayout } from '../TableLayout';

export const renderTableBodySkeleton = () =>
  Array(10)
    .fill(undefined)
    .map((_, index) => (
      <TableRowLayout
        key={index}
        avatar={<Avatar size="large" variant="icon" name="" loading />}
        manuallyAdded={null}
        name={<TextSkeleton width="80%" />}
        phoneNumber={<TextSkeleton width="50%" height="xsmall" />}
        status={<TextSkeleton width="50%" />}
        mostRecentRole={<TextSkeleton width="70%" />}
        mostRecentCompanyName={<TextSkeleton width="40%" height="xsmall" />}
        mostRecentRoleMobile={<TextSkeleton width="70%" />}
        mostRecentApplication={<TextSkeleton width="70%" />}
        relativeApplicationTime={<TextSkeleton width="40%" height="xsmall" />}
        previousApplications={<TextSkeleton width="30px" />}
        actions={<TextSkeleton width="80px" />}
      />
    ));
